<template>
  <div class="animated fadeIn">
    <div v-if="loading">
      <BlockUI :message="blockuimsg"></BlockUI>
    </div>
    <b-container>
      <b-row align-h="center">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header text-center bg-primary">
              {{ $t("TemplateEditorList") }}
            </div>
            <div class="card-body">
              <b-button
                size="m"
                @click="onNew()"
                variant="info"
                class="mb-2"
              >
                <strong>{{ $t("NewTemplate") }}</strong>
              </b-button>
              <b-row>
                <b-table
                  striped
                  hover
                  small
                  :items="files"
                  :fields="templateFields"
                >
                  <template slot="actions" slot-scope="row">
                    <b-button
                      size="sm"
                      @click="onEdit(row.item, false)"
                      class="mr-1"
                    >
                      {{ $t("Edit") }}
                    </b-button>
                    <b-button
                      size="sm"
                      @click="onEdit(row.item, true)"
                      class="mr-1"
                    >
                      {{ $t("Duplicate") }}
                    </b-button>
                    <b-button
                      size="sm"
                      @click="onDelete(row.item)"
                      class="mr-1"
                    >
                      {{ $t("Delete") }}
                    </b-button>
                  </template>
                </b-table>
              </b-row>
            </div>
          </div>
        </div>
      </b-row>
    </b-container>

    <b-modal
      ref="mdlTemplate"
      :title="templateId == -1 ? $t('NewTemplate') : $t('EditTemplate')"
      size="xl"
    >
      <b-form @submit.stop.prevent="onSave">
        <b-row>
          <div class="col-md-6">
            <b-form-group :label="$t('TemplateName')" label-for="TemplateName">
              <b-form-input
                type="text"
                id="TemplateName"
                v-model="templateName"
                required
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group :label="$t('TemplateType')" label-for="TemplateType">
              <b-form-select
                type="text"
                id="TemplateType"
                v-model="templateTypeId"
                :options="templateTypeOptions"
                :disabled="templateId == -1 ? false : true"
                @change="showDetails($event)"
                required
              ></b-form-select>
            </b-form-group>
          </div>
        </b-row>
        <b-row>
          <div style="padding: 12px">
            <b-table
              striped
              hover
              small
              fixed
              :items="details"
              :fields="detailFields"
              primary-key="id"
            >
              <template slot="solapa" slot-scope="row">
                <b-form-input
                  v-if="row.item.ver_solapa"
                  type="text"
                  v-model.lazy="row.item.solapa"
                  :value="[[row.item.solapa]]"
                  required
                />
              </template>
              <template slot="columna" slot-scope="row">
                <b-form-input
                  v-if="row.item.ver_columna"
                  type="text"
                  v-model.lazy="row.item.columna"
                  :value="[[row.item.columna]]"
                  required
                />
              </template>
              <template slot="fila" slot-scope="row">
                <b-form-input
                  v-if="row.item.ver_fila"
                  type="number"
                  v-model.lazy="row.item.fila"
                  :value="[[row.item.fila]]"
                  min="1"
                  required
                />
              </template>
            </b-table>
          </div>
        </b-row>
        <b-row class="modal-footer">
          <b-button variant="secondary" size="m" @click="hideModal" class="mr-1"
            >{{ $t("Cancel") }}
          </b-button>
          <b-button type="submit" size="m" variant="primary" class="mr-1">{{
            $t("Save")
          }}</b-button>
        </b-row>
      </b-form>
      <div slot="modal-footer">
        <!-- Evita doble boton de guardar y cancelar -->
      </div>
    </b-modal>

    <ConfirmDialog ref="ConfirmDialog"></ConfirmDialog>
  </div>
</template>
<script>
import ConfirmDialog from "../dialog/ConfirmDialog";
import excelColumnName from "excel-column-name";

export default {
  components: {
    ConfirmDialog,
  },
  data() {
    return {
      loading: false,
      files: [],
      details: [],
      templateTypeOptions: [],
      templateTypeId: null,
      templateFields: {
        actions: {
          label: this.$i18n.t("Actions"),
        },
        nombre: {
          label: this.$i18n.t("Name"),
        },
        tipo: {
          label: this.$i18n.t("TemplateType"),
        },
      },
      detailFields: {
        grupo: {
          label: this.$i18n.t("Group"),
          sortable: true,
        },
        nombre: {
          label: this.$i18n.t("Campo"),
          sortable: true,
        },
        tipo: {
          label: this.$i18n.t("Tipo"),
          sortable: true,
          thStyle: { width: "130px" },
        },
        solapa: {
          label: this.$i18n.t("Solapa"),
        },
        columna: {
          label: this.$i18n.t("Columna"),
          thStyle: { width: "80px" },
        },
        fila: {
          label: this.$i18n.t("Fila"),
          thStyle: { width: "80px" },
        },
      },
      templateId: -1,
      templateName: "",
      templateProtocolId: 0,
    };
  },
  methods: {
    async loadData() {
      this.loading = true;
      var response = await this.$http.get("/api/plantillas/list");
      if (response.body.Ok) {
        this.files = response.body.Data;
      } else {
        this.showToastedMsg(response.body.Message, "error");
      }

      response = await this.$http.get("/api/plantillas/listComboTipos");
      if (response.body.Ok) {
        response.body.Data.forEach((element) => {
          this.templateTypeOptions.push({
            value: element.id,
            text: `[${element.id}] ${element.text}`,
          });
        });
      } else {
        this.showToastedMsg(response.body.Message, "error");
      }

      this.loading = false;
    },
    hideModal() {
      this.details = [];
      this.$refs.mdlTemplate.hide();
    },
    async showDetails(newTemplateTypeId) {
      this.details = [];

      this.templateTypeId = newTemplateTypeId;
      var responseListaCampos = await this.$http.get(
        "/api/plantillas/listCampos?id=" + newTemplateTypeId
      );

      if (!responseListaCampos.body.Ok) {
        this.showToastedMsg(responseListaCampos.body.Message, "error");
        return;
      }
  
      this.details = responseListaCampos.body.Data.map((x, i) => ({
        id: i,
        nombre: x.nombre,
        tipo: x.tipo,
        grupo: x.grupo,
        campo: x.id,
        solapa: "",
        columna: "A",
        fila: 1,
        ver_columna: x.ver_columna,
        ver_fila: x.ver_fila,
        ver_solapa: x.ver_solapa,
        orden: x.orden,
      }));
    },
    async onSave() {
      this.loading = true;
      var self = this;
      var data = {
        id: self.templateId,
        nombre: self.templateName,
        ref_plantillas_tipos: self.templateTypeId,
        detalles: [],
      };
      for (let i = 0; i < self.details.length; i++) {
        data.detalles.push({
          ref_plantillas_campos: self.details[i].campo,
          solapa: self.details[i].solapa,
          columna: excelColumnName.excelColToInt(self.details[i].columna) - 1,
          fila: --self.details[i].fila,
        });
      }

      try {
        var response = await this.$http.post("/api/plantillas/save", data);
        if (response.body.Ok) {
          this.showToastedMsg(self.$t("SavedTemplate"), "success");
          this.$refs.mdlTemplate.hide();
          this.loadData();
        } else {
          this.showToastedMsg(response.body.Message, "error");
        }
      } catch (e) {
        if (!response.body.Ok) {
          this.showToastedMsg(response.body.Message, "error");
        }
      }
      this.loading = false;
      this.hideModal();
    },
    async onNew() {
      this.details = [];
      this.templateId = -1;
      this.templateName = "";
      this.templateTypeId = 0;
      this.$refs.mdlTemplate.show();
    },
    async onEdit(item, isDuplicate) {
      var responsePlantilla = await this.$http.get(
        "/api/plantillas/get?id=" + item.id
      );

      if (!responsePlantilla.body.Ok) {
        this.showToastedMsg(responsePlantilla.body.Message, "error");
        return;
      }

      this.templateTypeId = responsePlantilla.body.Data.tipo.id;
      var responseListaCampos = await this.$http.get(
        "/api/plantillas/listCampos?id=" + responsePlantilla.body.Data.tipo.id
      );

      if (!responseListaCampos.body.Ok) {
        this.showToastedMsg(responseListaCampos.body.Message, "error");
        return;
      }

      var details = this.getFullTemplateDetails(
        responsePlantilla.body.Data.detalles,
        responseListaCampos.body.Data
      );

      this.templateId = isDuplicate ? -1 : item.id;
      this.templateName = isDuplicate ? "" : item.nombre;
      this.templateTypeId = responsePlantilla.body.Data.tipo.id;

      this.details = details;
      this.$refs.mdlTemplate.show();
    },
    async onDelete(item) {
      var self = this;

      let resConfirmation = await self.$refs.ConfirmDialog.ShowConfirmation(
        self.$t("DeleteRecordConfirm")
      );

      if (resConfirmation) {
        try {
          this.loading = true;
          var response = await this.$http.post("/api/plantillas/delete", item);
          if (response.body.Ok) {
            this.showToastedMsg(
              self.$t("RecordDeteledSuccessfully"),
              "success"
            );
            this.loadData();
          } else {
            this.showToastedMsg(response.body.Message, "error");
          }
        } catch (ex) {
          if (!response.body.Ok) {
            this.showToastedMsg(response.body.Message, "error");
          }
        }
      }
      this.loading = false;
    },
    getFullTemplateDetails(detalles, campos, isNew) {
      var details = [];
      for (var p = 0; p < campos.length; p++) {
        for (var t = 0; t < detalles.length; t++) {
          if (detalles[t].campo === campos[p].id) {
            details.push({
              id: campos[p].id,
              nombre: campos[p].nombre,
              tipo: campos[p].tipo,
              grupo: campos[p].grupo,
              campo: detalles[t].campo,
              solapa: isNew ? "1" : detalles[t].solapa,
              columna: isNew
                ? "A"
                : excelColumnName.intToExcelCol(++detalles[t].columna),
              fila: isNew ? 1 : ++detalles[t].fila,
              ver_columna: campos[p].ver_columna,
              ver_fila: campos[p].ver_fila,
              ver_solapa: campos[p].ver_solapa,
              orden: campos[p].orden
            });
          }
        }
      }
      return details;
    },
    showToastedMsg(msg, type) {
      this.$toasted.show(msg, {
        theme: "outline",
        type: type,
        duration: 5000,
      });
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>
